import { render } from "./AppInputStyleSwitch.vue?vue&type=template&id=6d9cf7fe"
import script from "./AppInputStyleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInputStyleSwitch.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/core/layout/AppInputStyleSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d9cf7fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d9cf7fe', __exports__)) {
    console.log('reload')
    api.reload('6d9cf7fe', __exports__)
  }
  
  module.hot.accept("./AppInputStyleSwitch.vue?vue&type=template&id=6d9cf7fe", () => {
    console.log('re-render')
    api.rerender('6d9cf7fe', render)
  })

}


export default __exports__